import API from "./API";
import axios from "axios";

export const Tags = {

    async getAll(type){
        const query = type ? ('?type=' + type) : '';
        const url = API.url('/tags' + query);
        return await axios.get(url);
    }, 

    async getTypes(){
        const url = API.url('/admin/tags/types');
        return await axios.get(url);
    },

    async getOne(id){
        const url = API.url('/tags/' + id);
        return await axios.get(url);
    },

    async post(data){
        const url = API.url('/admin/tags');
        return await axios.post(url, data);
    },

    async put(data){
        const url = API.url('/admin/tags/' + data.id);
        return await axios.put(url, data);
    },

    async delete(id){
        const url = API.url('/admin/tags/' + id);
        return await axios.delete(url);
    },

    async link(parentId, childId){
        const url = API.url('/admin/tags/' + parentId + '/links/' + childId);
        return await axios.post(url, null);
    },

    async deleteLink(parentId, childId){
        const url = API.url('/admin/tags/' + parentId + '/links/' + childId);
        return await axios.delete(url);
    },

}

export default Tags;